<template>
    <div>
        <app-form
            v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            errMsg: this.errMsg,
            isEdit: this.isEdit,
            }"
            v-on:input="formData = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />
        <div v-if="isErr">
            <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
      </div>
    </div>
</template>
  
<script>
import PMRewardRecordForm from "../../../components/performance/reward/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": PMRewardRecordForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('pmrewardrecord.createsimulationrecord'),

            formData: {

                simulationcode: null,
                simulationdesc: null,
                assessmentrecordid: null,
                statusid: null,
                isfinalrecord: 0,//default false
                currencyid: null,

                stamp: 0,
                updatedby: this.$store.getters.userId,
                
                //read only,4 column
                startdate: null,
                enddate: null,
                assessmentcode: null,
                currencycode: null,

            },

            errMsg: "",
            isErr: false,
            isEdit: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        async saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                console.error("cannot add");
                return false;
            }

            try {
                const res = await this.$store.dispatch('post', {
                    url: "/pmrewardrecord/create",
                    payload: this.formData
                });

                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    this.$router.push({ name: "pmrewardrecordedit", params: { id: res.data.id } });
                }
            } catch (err) {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            }
        }
    },

    created() {

    },

    mounted() {

    },
};
</script>